import Vue from 'vue'
import Router from 'vue-router'
import smoothScroll from 'smoothscrolljs'

import store from '@/store'
import { SET_LOCALE, SET_REFERRAL } from '@/store/mutation-types'
import { isValidLocale, getLocale } from '@/locale'

import HomeContainer from '@/containers/Home'
import AboutContainer from '@/containers/About'
import TeamContainer from '@/containers/Team'
import ContactContainer from '@/containers/Contact'
import ProjectsContainer from '@/containers/Projects'
import DetailsContainer from '@/containers/Details'

Vue.use(Router)

const routes = [
  {
    path: '/:locale?/p/:id',
    name: 'details',
    component: DetailsContainer,
    beforeEnter (to, from, next) {
      const { params = {} } = to

      store.dispatch('fetchProject', parseInt(params.id))
        .then(next)
        .catch(() => {
          next({ name: 'home' })
        })
    }
  },
  {
    path: '/:locale?/projects',
    name: 'projects',
    component: ProjectsContainer,
    meta: {
      title: 'projects' // title is an i18n key
    }
  },
  {
    path: '/:locale?/contact',
    name: 'contact',
    component: ContactContainer,
    meta: {
      title: 'contact'
    }
  },
  {
    path: '/:locale?/team',
    name: 'team',
    component: TeamContainer,
    meta: {
      title: 'team'
    }
  },
  {
    path: '/:locale?/about',
    name: 'about',
    component: AboutContainer,
    meta: {
      title: 'about'
    }
  },
  {
    path: '/:locale?',
    name: 'home',
    component: HomeContainer
  },
  {
    path: '*',
    name: 'not-found',
    component: HomeContainer
  }
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    const position = savedPosition || { x: 0, y: 0 }

    smoothScroll(position.y, { duration: 300 })

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Forces in-viewport directive to recheck
        const fakeScrollEvent = new Event('scroll')
        window.dispatchEvent(fakeScrollEvent)
      }, 700)
    })
  }
})

router.beforeEach((to = {}, from = {}, next) => {
  const { locale = getLocale() } = to.params

  store.commit(SET_REFERRAL, from)

  if (!isValidLocale(locale)) {
    next({ name: 'not-found', params: { locale: getLocale() } })
  } else {
    store.commit(SET_LOCALE, locale)
    next()
  }
})

export { routes }
export default router



// WEBPACK FOOTER //
// ./src/router.js